<template>
    <div class="personalData">
        <form action="" id="my_data">
            <div class="head-portrait">
                <label>{{$t("head_portrait")}}</label>
                <input id="pic1" type="hidden" value="" name="photo" class="image_photo">
                <!-- <img id="pic" src="../../assets/images/personalCenter/photo.png"> -->
                <img id="pic" :src="user_headImg_show">
                <a href="javascript:;" class="file">
                    <input type="file" name="" id="headPortraitUpload" @change="headPortraitListener($event)">
                </a>
            </div>
            <div class="import"><label>{{$t("compellation")}}</label>
                <input type="text" v-model="user_name" name="username" :placeholder="$t('placeholder_name')"></div>
            <label>{{$t("certificate_card")}}</label>
            <input type="text" v-model="user_idCard" name="IdCard" :placeholder="$t('placeholder_card')" >
            <label>{{$t("sex")}}</label>
            <div id="select">
                <select name="sex" class="sel" v-model="user_sex">
                    <option value="1">{{$t("sex_men")}}</option>
                    <option value="2">{{$t("sex_women")}}</option>
                </select>
            </div>
            <label>{{$t('age')}}</label>
            <input type="number" min="1" max="200"  v-model="user_age" name="age" :placeholder="$t('placeholder_age')" autofocus="autofocus" autocomplete="off" onkeyup="this.value=this.value.replace(/[^\d]/g,'')" >
            <div class="import">
                <label>{{$t('phone')}}</label>
                <input type="text" name="phone" v-model="user_tel" disabled  autofocus="autofocus" autocomplete="off">

            </div>

            <label>{{$t("mail")}}</label>
            <input type="text" name="email" v-model="user_email" :placeholder="$t('placeholder_mail')" autofocus="autofocus" autocomplete="off">

            <label>{{$t("address")}}</label>
            <input type="text" name="address" v-model="user_address" :placeholder="$t('placeholder_address')" autofocus="autofocus" autocomplete="off">
            <button type="button" id="affirm" @click="submitData()">{{$t('submit_data')}}</button>
        </form>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
  name: "personalData",
  data: function() {
    return {
      isActive: false,
      hasError: false,
      user_headImg_show: "",
      user_headImg_ajax: "",
      user_name: "",
      user_idCard: "",
      user_sex: 1,
      user_tel: "",
      user_email: "",
      user_address: "",
      user_age: ""
      // base64head:"",
    };
  },
  created() {
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "personal_info");
    this.getPersonalData();
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    },
    hurl: function() {
      return this.$store.state.hurl;
    }
  },
  methods: {
    // 获取当前用户的个人信息
    getPersonalData: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/user/userInfo",
        dataType: "json",
        data: {}
      })
        .then(res => {
          console.log(res);
          if (res.data.status === 1) {
            this.user_headImg_ajax = res.data.result.head_pic;
            this.user_headImg_show = res.data.result.head_pic.replace(
              "/public",
              this.weburl + "/public"
            );
            this.user_name = res.data.result.nickname;
            this.user_idCard = res.data.result.certificate;

            if (res.data.result.sex == 0) {
              this.user_sex = 1;
            } else {
              this.user_sex = res.data.result.sex;
            }
            this.user_tel = res.data.result.mobile;
            this.user_email = res.data.result.email;
            this.user_address = res.data.result.address;
            this.user_age = res.data.result.age;
          }
        })
        .catch(err => {
          Toast("系统错误,请稍后再试!");
          console.log(err);
        });
    },
    headPortraitListener: function(e) {
      let file = e.target.files[0];
      this.file = file;
      let reader = new FileReader();
      let that = this;
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        // that.user_headImg = reader.result;
        // console.log(that.user_headImg.);
        that.user_headImg_show = reader.result;
        that.user_headImg_ajax = reader.result;
        // that.$http({
        //     xhrFields: {
        //         withCredentials: true
        //     },
        //     crossDomain: true,
        //     method: "post",
        //     url: that.weburl + that.hurl + "/user/imgSave",
        //     dataType: "json",
        //     data: {
        //         head_pic: that.base64head
        //     },
        // })
        // .then(res => {
        //     if(res.status == 200){
        //         Toast("图片上传成功");
        //         that.user_headImg = that.weburl + res.data;
        //     }else{
        //         Toast("上传失败，稍后再试");
        //     }
        // })
        // .catch(err => {
        //     console.log(err);
        // })
      };
    },
    submitData: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/user/saveUserInfo",
        dataType: "json",
        data: {
          head_pic: this.user_headImg_ajax,
          name: this.user_name,
          certificate: this.user_idCard,
          sex: this.user_sex,
          mobile: this.user_tel,
          email: this.user_email,
          address: this.user_address,
          age: this.user_age
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 1) {
            Toast("提交成功");
            setTimeout(() => {
              this.$router.push({ path: `/personalCenter` });
            }, 1000);
          } else {
            Toast("网络错误，稍后再试");
          }
        })
        .catch(err => {
          Toast("系统错误,请稍后再试!");
          console.log(err);
        });
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/information.less";

.personalData {
  .padding;
  #affirm {
    .btn;
    .width;
    display: block;
  }
  #select {
    width: 77%;
    height: calc(100% - 1px);
    .border-bottom(1px, #e0e0e0);
    font-size: 0.9rem;
    position: relative;
    display: inline-block;
    select {
      width: @width;
      height: 92%;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
    }
    &:after {
      content: "";
      right: 0;
      top: -136%;
      background: url("@{sprite}") no-repeat -281px 0px;
      width: 31px;
      height: 36px;
      background-size: 315px auto;
      pointer-events: none;
    }
  }
}
</style>
